export const ATF = '[ACTIVE TIME]'
export const ADVANCE_TURN = `${ATF} Advance Turn`
export const RESET_ATF = `${ATF} Reset Turn State`

export const advanceTurn = tick => ({
    type: ADVANCE_TURN,
    payload: {
        tick,
    },
    meta: {
        processBattle: 'calculate',
    },
})

export const resetActiveTime = () => ({
    type: RESET_ATF,
    payload: {},
})
